import type { Task } from '@/src/renderer/lib/db/models'
import type { StagedAction } from './useClarifyState'
import { ClarifyEntryList } from './ClarifyEntryList'
import { ClarifyActionPanel } from './ClarifyActionPanel'
import './ClarifyBody.scss'

export interface ClarifyBodyProps {
  queue: Task[]
  activeTaskId: string | null
  activeTask: Task | null
  staged: Map<string, StagedAction>
  stackIds: string[]
  lifeSpace: 'personal' | 'work' | 'home'
  onSelectActive: (taskId: string) => void
  onStage: (action: StagedAction) => void
  onAnyDropdownOpenChange: (open: boolean) => void
}

/**
 * Two-column body of the Clarify-Mode. Left column is the scrollable list of
 * inbox entries (with the stack-overlay), right column is the action panel
 * for the currently active entry. The controller (state + keyboard + commit)
 * lives in the parent via `useClarifyController`; this component is purely
 * presentational.
 */
export function ClarifyBody({
  queue,
  activeTaskId,
  activeTask,
  staged,
  stackIds,
  lifeSpace,
  onSelectActive,
  onStage,
  onAnyDropdownOpenChange,
}: ClarifyBodyProps) {
  return (
    <div className="clarify-body">
      <ClarifyEntryList
        queue={queue}
        activeTaskId={activeTaskId}
        staged={staged}
        stackIds={stackIds}
        onSelectActive={onSelectActive}
      />
      <ClarifyActionPanel
        activeTask={activeTask}
        activeStagedAction={activeTaskId ? staged.get(activeTaskId) : undefined}
        lifeSpace={lifeSpace}
        onStage={onStage}
        onAnyDropdownOpenChange={onAnyDropdownOpenChange}
      />
    </div>
  )
}
